import React from 'react';

const context = React.createContext({
  breadcrumbs: [],
  setBreadcrumbs: () => {},
});
context.displayName = 'BreadCrumbsContext';

export default context;
